import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { Link } from 'react-scroll';

const FooterPage = ({ onApplyClick }) => {
  const [isPulsing, setIsPulsing] = useState(false);

  useEffect(() => {
    const handleTrigger = () => {
      setIsPulsing(true);
      // Return to normal size after 1 second
      setTimeout(() => setIsPulsing(false), 1100);
    };

    window.addEventListener('highlight-footer', handleTrigger);
    return () => window.removeEventListener('highlight-footer', handleTrigger);
  }, []);

  return (
    <>
      <footer
        id="contact"
        className="relative z-20 text-white py-10 sm:py-12 md:py-14 lg:py-16 bg-cover bg-center"
        style={{ backgroundImage: "url('/images/bg-2.png')" }}
      >
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black/10"></div>
        
        <div className={`max-w-7xl mx-auto px-6 relative z-10 transition-transform duration-500 ease-in-out ${
          isPulsing ? 'scale-105' : 'scale-100'
        }`}>
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
            
            {/* Contact Us Section - Left Side (Wider) */}
            <div className="flex-1 lg:max-w-xl">
              <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-5">
                Contact us
              </h2>
              <p className="text-sm sm:text-base text-white/90 leading-relaxed mb-6 sm:mb-8">
                PYLON Hub fosters innovation and entrepreneurship by supporting technology-based startups and empowering students and faculty.
              </p>
              <p className="text-xs sm:text-sm text-white/80">
                © 2024 Technology Business Incubation and Development Office
              </p>
            </div>

            {/* Right Side - Quick Links and Contacts */}
            <div className="flex flex-col sm:flex-row gap-8 sm:gap-12 lg:gap-16">
              
              {/* Quick Links Section */}
              <div className="min-w-[180px]">
                <h2 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-5">
                  Quick Links
                </h2>
                <ul className="space-y-2.5 sm:space-y-3">
                  <li>
                    <a 
                      href="https://www.facebook.com/DOSTPUPPYLONTBI" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-sm sm:text-base text-white/90 hover:text-white hover:underline transition-all duration-200 inline-block"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://www.pup.edu.ph/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-sm sm:text-base text-white/90 hover:text-white hover:underline transition-all duration-200 inline-block"
                    >
                      Official Website
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://maps.app.goo.gl/WJ8xPWPG2fALvPGZ9" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm sm:text-base text-white/90 hover:text-white hover:underline transition-all duration-200 inline-block"
                    >
                      TBIDO Address
                    </a>
                  </li>
                  <li>
                    <button
                      onClick={onApplyClick}
                      className="text-sm sm:text-base text-white/90 hover:text-white hover:underline transition-all duration-200 focus:outline-none text-left"
                    >
                      Apply Now
                    </button>
                  </li>
                </ul>
              </div>

              {/* Contacts Section */}
              <div className="min-w-[200px]">
                <h2 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-5">
                  Contacts
                </h2>
                <ul className="space-y-2.5 sm:space-y-3">
                  <li>
                    <a 
                      href="mailto:tbido@pup.edu.ph"
                      className="text-sm sm:text-base text-white/90 hover:text-white hover:underline transition-all duration-200 inline-block"
                    >
                      tbido@pup.edu.ph
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://www.facebook.com/DOSTPUPPYLONTBI" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm sm:text-base text-white/90 hover:text-white hover:underline transition-all duration-200 inline-block"
                    >
                      fb.com/DOSTPUPPYLONTBI
                    </a>
                  </li>
                  <li>
                    <p className="text-sm sm:text-base text-white/90">
                      PUP Sta. Mesa, Manila
                    </p>
                  </li>
                </ul>
              </div>

            </div>

          </div>
        </div>
      </footer>

      {/* Modal */}
      
    </>
  );
};

export default FooterPage;